<template>
    <v-card class="ma-2 english-level-card">
        <v-card-title class="card-employee-title english-card-title">
            Facilities
            <v-tooltip bottom class="salary-add-button">
                <v-btn :disabled="!isEditEnabled" flat color="black" @click="addNewFacility()" slot="activator" class="add-facility-btn">
                    <v-icon small color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new facility</div>
            </v-tooltip>
        </v-card-title>
        <v-card-text class="english-text-card">
            <v-container fluid grid-list-xl class="flex-container" v-for="(facility, index) in facilities" :key="index">
                <v-layout wrap align-center>
                    <v-flex class="english-level-card" xs4>
                        <v-select content-class="english-level" v-bind:items="facilityDevicesList" class="select-card english-level-select"
                            v-model="facility.device" label="Device" single-line bottom :disabled="!isEditEnabled" required
                            item-text="name" item-value="id" return-object @change="changeFacilityDevice($event, index)"
                            :rules="facility.modelNumber || facility.type ? requiredRulesFacilityDevice : []"
                        ></v-select>
                    </v-flex>
                    <v-flex class="english-level-card" xs4>
                        <v-select content-class="english-level" v-bind:items="facilityTypesList" class="select-card english-level-select"
                            v-model="facility.type" label="Type" single-line bottom :disabled="!isEditEnabled" required
                            item-text="name" item-value="id" return-object @change="changeFacilityType($event, index)"
                            :rules="facility.modelNumber || facility.device ? requiredRulesFacilityType : []"
                        ></v-select>
                    </v-flex>
                    <v-flex class="english-level-card" xs4>
                        <v-layout>
                            <v-text-field v-model="facility.modelNumber" label="Number" class="input-card"
                                required :disabled="!isEditEnabled" @change="changeFacilityNumber($event, index)"
                                :rules="facility.device || facility.type ? requiredRulesFacilityNumber : []"
                            ></v-text-field>
                            <v-tooltip bottom class="facility-icon">
                                <v-btn icon slot="activator" @click.stop="removeFacility(index)" class="delete-icon" :disabled="!isEditEnabled">
                                    <v-icon color="grey">mdi-delete</v-icon>
                                </v-btn>
                                <span>Delete</span>
                            </v-tooltip>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'EmployeeFacility',
        data() {
            return {
                requiredRulesFacilityNumber: [
                    (v) => !!v || 'Enter facility number'
                ],
                requiredRulesFacilityDevice: [
                    (v) => !!v || 'Enter facility device'
                ],
                requiredRulesFacilityType: [
                    (v) => !!v || 'Enter facility type'
                ]
            };
        },
        computed: {
            ...mapGetters({
                employee: 'getEmployee',
                facilityDevices: 'getFacilityDevices',
                facilityTypes: 'getFacilityTypes'
            }),
            facilityDevicesList: {
                get() {
                    return this.facilityDevices.map(d => ({ name: d.name, id: d.id }));
                }
            },
            facilityTypesList: {
                get() {
                    return this.facilityTypes.map(d => ({ name: d.name, id: d.id }));
                }
            },
            facilities: {
                get() {
                    return this.employee.facilities;
                }
            },
            isEditEnabled() {
                return !this.employee.archived;
            }
        },
        methods: {
            ...mapActions([
                'addEmployeeFacility',
                'removeEmployeeFacility',
                'changeEmployeeFacilityDevice',
                'changeEmployeeFacilityType',
                'changeEmployeeFacilityNumber'
            ]),
            addNewFacility() {
                this.addEmployeeFacility();
            },
            removeFacility(index) {
                this.removeEmployeeFacility(index);
            },
            changeFacilityDevice(value, index) {
                this.changeEmployeeFacilityDevice({ name: value.name, id: value.id, index });
            },
            changeFacilityType(value, index) {
                this.changeEmployeeFacilityType({ name: value.name, id: value.id, index });
            },
            changeFacilityNumber(value, index) {
                this.changeEmployeeFacilityNumber({ value, index });
            }
        }
    };
</script>

<style scoped>
    .menu__content.menu__content--select.menuable__content__active {
        max-height: 304px !important;
    }
    .english-level-select >>> .input-group__selections__comma {
        margin-top: 6px;
    }
    .flex-container {
        padding: 18px 0 0 0 !important;
    }
    .input-card >>> .input-group__input {
        min-height: 30px !important;
    }
    .item-add-button-icon.btn {
        max-width: 24px;
        max-height: 24px;
    }
    .add-facility-btn >>> .btn__content {
        padding: 0;
    }
    .add-facility-btn {
        min-width: 24px;
        width: 24px;
        min-height: 24px;
        height: 24px;
        margin: 6px 0px 6px 12px;
        background-color: #CED2E6 !important;
    }
    .facility-icon {
        align-self: center;
    }
    .delete-icon.btn.btn--icon .mdi.icon.grey--text.mdi-delete, 
    .edit-icon.btn.btn--icon .mdi.icon.grey--text.edit {
        font-size: 20px;
    }
    .delete-icon.btn.btn--icon {
        margin: 0 12px 0 0;
    }
    .edit-icon.btn.btn--icon {
        margin-right: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/reusable/EmployeeFacility.vue